<template>
    <TagStatus :id="state" :label="label" size="small" type="ocr" />
</template>

<script>
import TagStatus from 'vcomponents/common/TagStatus/TagStatus.vue';

export default {
    components: {
        TagStatus,
    },
    inheritAttrs: false,
    props: {
        state: {
            type: String,
            required: true,
        },
    },
    computed: {
        label() {
            switch (this.state) {
                case 'completed':
                    return this.$l10n.__('Traité');
                case 'error':
                    if (this.errorCode === 1) {
                        return this.$l10n.__('Erreur nombre de pages');
                    } else {
                        return this.$l10n.__('Erreur technique');
                    }
                case 'pending':
                case 'processing':
                    return this.$l10n.__('En cours de traitement');
                default:
                    return this.$l10n.__('En cours de traitement');
            }
        },
    },
};
</script>
